module.exports = __webpack_public_path__ + "static/media/pic-history4.265e7b60.webp";